export default __webpack_public_path__ + "static/media/halonasoft-picturemark-l.01a37bef.svg";